export default () => {
  customElements.define(
    'tool-tip',
    class ToolTip extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const itemArea = document.querySelector(`[aria-describedby="${this.id}"]`);
        const tooltipArea = document.querySelector(`#${this.id}`);

        itemArea?.addEventListener('click', () => {
          this.classList.toggle('clicked');
        });
        document.addEventListener('click', (e) => {
          if (!itemArea.contains(e.target) && !tooltipArea.contains(e.target) && this.classList.contains('clicked')) {
            this.classList.toggle('clicked');
          }
        });
      }
    },
  );
};
